"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressService = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../config/config");
const api_1 = require("./api");
const PATH = '/location/api/v1';
class AddressService {
    static async getAllCountries() {
        try {
            return await axios_1.default.get(`${config_1.react_core_config.internalConfig.addressBaseUrl}/countries.json`);
        }
        catch (e) {
            throw e;
        }
    }
    static async getStates() {
        try {
            return await axios_1.default.get(`${config_1.react_core_config.internalConfig.addressBaseUrl}/states.json`);
        }
        catch (e) {
            throw e;
        }
    }
    static async getCities() {
        try {
            return await axios_1.default.get(`${config_1.react_core_config.internalConfig.addressBaseUrl}/cities.json`);
        }
        catch (e) {
            throw e;
        }
    }
    static async getAllCountriesV1() {
        try {
            return await api_1.API.get({
                url: `${PATH}/countries?page=0&size=9999&sort=featured,desc&sort=name,asc`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getStatesV1(id) {
        try {
            return await api_1.API.get({
                url: `${PATH}/countries/${id}/states`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getCitiesV1(id) {
        try {
            return await api_1.API.get({
                url: `${PATH}/states/${id}/cities`
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.AddressService = AddressService;
//# sourceMappingURL=address-service.js.map